module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAASdJREFUaAXtmN0OgjAMhcF7L7z251UlxviQ/r3KbBeXGCJshVOyhi6Zw1BOz/nKFU2juEIIHW/FFnrSX/N0xHXR66SgTJaZfH9dFVrhJcn1P/MpzA3fEaiYMc8h3rR3wJY4qULzJ1xHoJKbB8IUSTl5ES5gsZMHwhRJOXkRLmCxkwfCFEk5eREuYLGTB8IUSVkk36aEbJ6uz+m/lTMGsGqeIbeWzXOADf9YXvZfoUTf+qsUc3AI2mOLP4vU+WXhdxJjCeieh0iwVE8iXfI6HVVNzBUvCPGiGg8xF3T2eZ9EFtFCBQWTeFLNYSE709p4iGnc8E+tZRIPCrrH4wMqFkzCQwB5D0utZRJ3CrodxlDBncwkugos5i0MhLBhPsXrhbBlvhdC1fwHm/HC9po5WW4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ic-arrow-left.png
// module id = 331
// module chunks = 0